import { FC } from 'react';
import { buildAvatarImageSource } from '../../../../utils/buildAvatarImageSource';
import { useTranslation } from '../../../../utils/useTranslation';
import { Avatar } from '../../../media/Avatar';
import { Typography } from '../../../typography/Typography';
import { InfoColumn } from '../../styles';
import { AuthorBadgeViewProps } from '../../types';
import { getAuthorRole } from '../../utils/getAuthorRole';

export const AuthorBadgeView: FC<AuthorBadgeViewProps> = ({ collectionModel }) => {
    const t = useTranslation();
    const { author } = collectionModel;

    if (!author) {
        return null;
    }

    const avatarSrc = buildAvatarImageSource(author.avatarUrl);
    const role = getAuthorRole(author.authorType);

    return (
        <>
            <Avatar
                src={avatarSrc}
                title={author.displayName}
                size={48}
                minWidth={48}
                height={48}
            />
            <InfoColumn>
                <Typography
                    variant="body"
                    weight="bold"
                    width="100%"
                    overflow="hidden"
                    style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {author.displayName}
                </Typography>
                <Typography
                    variant="body2"
                    color="secondary"
                    width="100%"
                    overflow="hidden"
                    style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {t(role)}
                </Typography>
            </InfoColumn>
        </>
    );
};
